module.exports = __webpack_public_path__ + "img/economy-waterSavings.9d33a1d2.svg";